var _excluded = ["resize"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { TextArea as TextAreaSemantic } from 'semantic-ui-react';
import TextAreaCounter from "./TextAreaCounter";

/**
  * A TextArea can be used to allow for extended user textArea.
  *
  * @param {*} props
  * @see Form
  */
import { jsx as _jsx } from "react/jsx-runtime";
var TextArea = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TextArea, _React$Component);
  function TextArea(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    /**
       * Debounce the changes by 300ms.
       *
       * @memberof Input
       */
    _this.bouncedChange = _.debounce(function (event, data) {
      _.invoke(_this.props, 'onChange', event, data);
    }, 300);
    /**
       * Handle change.
       *
       * @memberof TextArea
       */
    _this.handleChange = function (event, data) {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        debounced = _this$props.debounced;
      _this.setState({
        value: event.target.value
      });
      if (debounced) {
        _this.bouncedChange(Object.assign({}, event), data);
      } else if (onChange) {
        onChange(event, data);
      }
    };
    /**
       * Render default.
       *
       * @memberof TextArea
       */
    _this.renderDefault = function () {
      var _this$props2 = _this.props,
        resize = _this$props2.resize,
        rest = _objectWithoutPropertiesLoose(_this$props2, _excluded);
      var value = _this.state.value;
      return /*#__PURE__*/_jsx(TextAreaSemantic, Object.assign({
        style: {
          resize: resize
        }
      }, _.omit(rest, ['debounced']), {
        onChange: _this.handleChange,
        value: value
      }));
    };
    var _value = props.value;
    _this.state = {
      value: _value,
      prevValue: _value
    };
    return _this;
  }

  /**
     * @description
     *
     * @static
     * @memberof Input
     */
  TextArea.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, previousState) {
    var prevValue = previousState.prevValue;

    // Compare the incoming prop to previous prop
    var value = prevValue !== nextProps.value ? nextProps.value : previousState.value;
    return {
      // Store the previous props in state
      prevValue: nextProps.value,
      value: value
    };
  };
  var _proto = TextArea.prototype;
  /**
     * Render the component.
     *
     * @returns
     * @memberof TextArea
     */
  _proto.render = function render() {
    var maxLength = this.props.maxLength;
    if (!_.isNil(maxLength)) {
      return /*#__PURE__*/_jsx(TextAreaCounter, Object.assign({}, _.omit(this.props, ['debounced']), {
        onChange: this.handleChange
      }));
    }
    return this.renderDefault();
  };
  return TextArea;
}(React.Component);
TextArea.handledProps = ["as", "debounced", "maxLength", "onChange", "onInput", "resize", "rows", "value"];
TextArea.propTypes = {
  /** An element type to render as (string or function). */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
  /** Whether or not the changes are debounced. */
  debounced: PropTypes.bool,
  /**
     * Called on change.
     * @param {SyntheticEvent} event - The React SyntheticEvent object
     * @param {object} data - All props and the event value.
     */
  onChange: PropTypes.func,
  /**
     * Called on input.
     * @param {SyntheticEvent} event - The React SyntheticEvent object
     * @param {object} data - All props and the event value.
     */
  onInput: PropTypes.func,
  /** Indicates row count for a TextArea. */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** The value of the textarea. */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  resize: PropTypes.oneOf(['none', 'vertical', 'horizontal', 'both']),
  maxLength: PropTypes.number
};
TextArea.defaultProps = {
  as: 'textarea',
  rows: 3,
  resize: 'none',
  debounced: true
};
export default TextArea;